import { graphql } from '@/api/graphql/codegen';

export const DeleteSeminarMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteSeminar($seminar: DeleteSeminarInput!) {
    deleteSeminar(deleteSeminarInput: $seminar) {
      id
    }
  }
`);
